const CancelablePromise = require('mn-utils/CancelablePromise');
const {
  get,
} = require('../http');
const {
  decorateReconnectIfSession,
  // decorateReconnect,
} = require('../_auth');


export const apiTestingWalletQr = decorateReconnectIfSession((params) => {
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      invoice: `${params.asset}:some-address?amount=${params.amount}`,
    });
  }
  return get('/v1/test/qr', params);
});
